import React from 'react';
import { Grid } from '@mui/material';
import FireblocksImage from '../FireblocksImage';
import { useTheme } from '@mui/system';

export const SealImagesBlock = () => {
  const theme = useTheme();
  return (
    <Grid
      item
      container
      alignItems={'center'}
      justifyContent={'center'}
      gap={'8px'}
      sx={{ opacity: 0.7 }}
    >
      <Grid item>
        <img
          src={`/images/signup/secure-ssh-${theme.palette.mode}.svg`}
          alt='ssl'
          id={'ssl_icon'}
        />
      </Grid>

      <FireblocksImage />
    </Grid>
  );
};

export default SealImagesBlock;
